import LocationIcon from '../icons/Location';
import ImageLoading from '../ImageLoading';
import NextLink from '../NextLink';
import DiscountTag from './DiscountTag';
import { formatImageThumbnail } from './utils/formatImageThumbnail';
import { Provider1FormattedHotelType } from './utils/provider1FormatHotel';

export default function Provider1HotelSquareCardV2({ hotel, navigateTo, square, onNavigate, onImageClick }:
    {
        navigateTo: string,
        hotel: Provider1FormattedHotelType;
        square?: boolean;
        onNavigate?: () => void,
        onImageClick?: () => void
    }) {

    return (
        <NextLink
            href={navigateTo}
            onClick={onNavigate}
            scroll={false}
            className={`z-10 flex flex-col relative min-w-full w-full
                     sm:h-full overflow-visible hover:scale-[97%] 
                     transition-transform duration-200`}
            key={hotel.code}
        >
            <div className='aspect-[0.94/1] rounded-lg overflow-hidden'>
                <ImageLoading
                    priority={false}
                    className='z-0 w-full block h-full'
                    alt='Hotel'
                    loading='lazy'
                    src={formatImageThumbnail(hotel.images?.[0]?.url)}
                    width={300}
                    height={300}
                />
            </div>
            <div className='flex mt-2 grow flex-col littleLine'>
                <p className='flex gap-1 items-center'>
                    <span className='size-5'><LocationIcon className="size-5" /></span>
                    <span className='capitalize'>{hotel.city}, </span>
                    <span className='capitalize'>{hotel.country}</span>
                </p>

                <div>
                    <p className='text-gray-800 line-clamp-2 cardTitle mt-1'>
                        {hotel.name}
                    </p>
                    <div className='text-amber-400 mt-1'>
                        {hotel.stars}
                    </div>
                    <div className='flex flex-col items-start gap-0.5'>
                        {hotel.offer &&
                            <DiscountTag discountPercent={(hotel.discountPercent)} />
                        }
                        <div className='flex  gap-1 items-center justify-start mt-2'>
                            <span className='text-xs text-gray-600'>From</span>
                            <span className='text-[20px] text-gray-800 font-bold'>{hotel.minimumPrice}</span>
                        </div>
                    </div>
                </div>
            </div>
        </NextLink>
    );
}
